import { AccountColor } from "./types.js";
import type { AccountColorConfig } from "./types.js";
/**
 * default account color => color config
 */
export const accountColorConfig: Partial<Record<AccountColor, AccountColorConfig>> = {
  [AccountColor.Pink]: {
    base: "#E07F9D",
    accent: "#C33D69",
  },
  [AccountColor.Purple]: {
    base: "#CBABFC",
    accent: "#6b40b2",
  },
  [AccountColor.Blue]: {
    base: "#7698fE",
    accent: "#4066df",
  },
  [AccountColor.LightBlue]: {
    base: "#44B9DD",
    accent: "#0166ab",
  },
  [AccountColor.Teal]: {
    base: "#40BFA9",
    accent: "#096f64",
  },
  [AccountColor.Green]: {
    base: "#7DBD4C",
    accent: "#1a7302",
  },
  [AccountColor.Yellow]: {
    base: "#DFB52C",
    accent: "#6f5504",
  },
  [AccountColor.Orange]: {
    base: "#F89256",
    accent: "#a84401",
  },
  [AccountColor.Red]: {
    base: "#FE6E73",
    accent: "#d13313",
  },
};

export const getConfigForAccountColor = (color: AccountColor) => accountColorConfig[color];

export * from "./types.js";
